import { LOCAL } from 'config';
import Cookie, { CookieAttributes } from 'js-cookie';

class CookieService {
  private cookieDomain = LOCAL ? '' : '.upstox.com';

  private watchers: CookieWatchers = {
    refresh_token: [],
    access_token: [],
    profile_id_web: [],
    profile_id: [],
    customer_status: [],
    user_type: [],
    user_id: [],
    app_load_start_time: [],
  };

  constructor() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (window.cookieStore) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.cookieStore.onchange = this.handleCookieChange;
    }
  }

  public subscribeCookieChange = (
    key: keyof CookieWatchers,
    handler: CookieChangeHandler,
  ) => {
    this.watchers[key].push(handler);
  };

  private handleCookieChange = ({ changed, deleted }: CookieChangeEvent) => {
    // go though all
    [...changed, ...deleted].forEach(({ domain, name, value }) => {
      // check if domain is upstox
      if (domain === 'upstox.com') {
        // there might be something else except known values like mixpanel_124124 cookie which set to upstox.com domain
        if (this.watchers[name]) {
          // notify watchers
          this.watchers[name].forEach(watcher => {
            const type = value ? 'change' : 'delete';

            watcher(type, name, value || null);
          });
        }
      }
    });
  };

  setItem = (
    key: CookieStorageKey,
    value: string,
    options: CookieAttributes = {
      domain: this.cookieDomain,
      expires: 1,
    },
  ) => {
    Cookie.set(key, value, options);
  };

  getItem = (key: CookieStorageKey) => Cookie.get(key) || null;

  removeItem = (key: CookieStorageKey, options: CookieAttributes) => {
    Cookie.remove(key, options);
  };
}

export default new CookieService();
